import { LoadingButton, LoadingButtonProps } from "@mui/lab";

// Botão primário das telas Branded. LoadingButton (contained, primary, fullWidth,
// disableElevation), SEM framer-motion/scale no hover e SEM margens próprias — o
// espaçamento é do gap da coluna. Altura fixa 44px e largura full garantem que o estado
// loading não altere o layout (sem "pulo"). Cores do tema; sem hex. Não substitui o
// StyledButton das telas Default.
export type BrandedButtonProps = LoadingButtonProps;

export const BrandedButton: React.FC<BrandedButtonProps> = ({ sx, ...props }) => (
  <LoadingButton
    variant="contained"
    color="primary"
    fullWidth
    disableElevation
    {...props}
    sx={{
      height: "4.4rem",
      fontSize: "1.5rem",
      fontWeight: 600,
      textTransform: "none",
      ...sx,
    }}
  />
);
